// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selections[data-v-700a80c4]{display:inline-flex;flex-wrap:wrap}.selections span[data-v-700a80c4]{padding-right:21px}`, "",{"version":3,"sources":["webpack://./src/shared/components/ncTable/partials/columnTypePartials/forms/UsergroupForm.vue"],"names":[],"mappings":"AACA,6BACI,mBAAA,CACA,cAAA,CAGJ,kCACI,kBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
